//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name: 'postUserHeader',
  created() {
    // do something
  },
  props: ['post'],
  data() {
    return {
    }
  },
  methods: {
    ...mapMutations(['setUserMsg']),

    goToUserMsg () {
      this.setUserMsg(this.post.user)
      // 跳转到用户信息
      this.$router.push({
        name: 'userMsg',
        params: {
          userId: this.post.user.objectId
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/post/PostUserHeader.vue